import React, { Component } from 'react';
import logo from './logo.svg';
import cat from './cat.png';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">


        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Hi, I'm Naib</h1>
          <p/>
          <h2 classname="App-title">I'm doing a bit of maintenance on my site right now.</h2>
          <h2 classname="App-title">Please check back shortly. </h2>
          <h2 classname="App-title"> Here's a cat in a bowl. </h2>
          <img src={cat} className="cat" alt="cat" height="300" />
        </header>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js